function getTimezoneOffsetInHours() {
  return Math.floor(new Date().getTimezoneOffset() / -60)
}

export default getTimezoneOffsetInHours
